<template>
  <div class="clickable progress" @click="$emit('click')">
    <h5>{{title}}</h5>
    <div class="chart">
      <doughnut-chart :chart-data="info" :options="options" />
    </div>
  </div>
</template>

<script>
import doughnutChart from "@/components/charts/doughnut/doughnut";
export default {
  props: ["title", "completed"],
  components: { doughnutChart },
  data() {
    return {
      info: {},
      options: {
        legend: {
          display: false
        },
        cutoutPercentage: 80,
      }
    };
  },
  created() {
    const colors = ["white", "rgba(255, 255, 255, .1)"];
    const data = [this.completed, 100 - this.completed];
    this.info = {
      labels: data,
      datasets: [{
        data,
        backgroundColor: colors,
        borderColor: colors,
        borderWidth: "1"
      }]
    };
  }
}
</script>

<style lang="less" scoped>

.progress {
  height: 100px + 15px + 15px;
  width: 100px;
  filter: brightness(0.7);
  @media (max-width: 500px) {
    flex: 1;
    min-width: 120px;
    margin: 10px 0px;
    align-items: center;
    justify-content: center;
    display: flex;
    flex-direction: column;
  }
  .chart {
    height: 100px;
    width: 100px;
    margin-top: 10px;
    margin: 10px auto;

    canvas {
      width: 100px;
      height: 100px;
    }

  }
  h5 {
    font-weight: 100;
    font-size: 15px;
    text-align: center;
    text-transform: uppercase;
  }
  &:hover {
    filter: brightness(1.0);
    h5 {
      font-size: 19px;
    }
    .chart {
      canvas {
        width: 120px;
        height: 120px;
      }
    }
  }
}
</style>
